var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuyonWhatsapp3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 167,
    viewBox: "0 0 168 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6359_86678)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.238 38.2983C157.216 37.7432 153.607 38.2983 150.962 38.2154C145.105 38.0065 139.249 37.8046 133.392 37.6096C116.687 37.0521 99.9821 36.55 83.2782 36.1031C66.2842 35.6586 49.2926 35.2624 32.2916 35.1426C26.7415 35.1058 20.8617 35.1426 15.1877 35.1749C11.2561 35.2048 5.14941 33.6385 2.17675 36.937C-0.374917 39.7655 0.785144 44.5981 0.850632 47.9933C0.923135 51.7133 1.04475 55.431 1.17807 59.1486C1.52578 68.7415 1.97015 78.3298 2.5112 87.9135C2.86671 94.363 3.40698 100.799 3.69232 107.251C3.97298 113.573 3.19414 120.057 4.28872 126.318C4.59043 128.036 5.16578 129.907 6.6907 130.791C7.59583 131.319 8.68573 131.402 9.73119 131.457C43.4104 133.203 76.9703 130.192 110.626 129.718C122.416 129.552 134.199 129.027 145.98 128.566C152.728 128.297 163.767 130.328 163.692 120.788C163.659 116.282 163.133 111.917 163.346 107.389C163.895 95.7612 164.418 84.1336 164.915 72.506C165.168 66.6063 165.413 60.7065 165.65 54.8067C165.813 50.7136 167.24 44.2387 164.553 40.6984C163.5 39.3026 161.971 38.6161 160.238 38.2983Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M160.238 38.2983C157.216 37.7432 153.607 38.2983 150.962 38.2154C145.105 38.0065 139.249 37.8046 133.392 37.6096C116.687 37.0521 99.9821 36.55 83.2782 36.1031C66.2842 35.6586 49.2926 35.2624 32.2916 35.1426C26.7415 35.1058 20.8617 35.1426 15.1877 35.1749C11.2561 35.2048 5.14941 33.6385 2.17675 36.937C-0.374917 39.7655 0.785144 44.5981 0.850632 47.9933C0.923135 51.7133 1.04475 55.431 1.17807 59.1486C1.52578 68.7415 1.97015 78.3298 2.5112 87.9135C2.86671 94.363 3.40698 100.799 3.69232 107.251C3.97298 113.573 3.19414 120.057 4.28872 126.318C4.59043 128.036 5.16578 129.907 6.6907 130.791C7.59583 131.319 8.68573 131.402 9.73119 131.457C43.4104 133.203 76.9703 130.192 110.626 129.718C122.416 129.552 134.199 129.027 145.98 128.566C152.728 128.297 163.767 130.328 163.692 120.788C163.659 116.282 163.133 111.917 163.346 107.389C163.895 95.7612 164.418 84.1336 164.915 72.506C165.168 66.6063 165.413 60.7065 165.65 54.8067C165.813 50.7136 167.24 44.2387 164.553 40.6984C163.5 39.3026 161.971 38.6161 160.238 38.2983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.57812 132.542H166.567",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.261 44.166H19.7734V132.541H149.261V44.166Z",
    fill: "#0E1213",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1275 116.339H85.1084C84.6473 116.339 84.2734 116.707 84.2734 117.161V118.675C84.2734 119.129 84.6473 119.497 85.1084 119.497H90.1275C90.5887 119.497 90.9625 119.129 90.9625 118.675V117.161C90.9625 116.707 90.5887 116.339 90.1275 116.339Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3463 116.339H92.3271C91.866 116.339 91.4922 116.707 91.4922 117.161V118.675C91.4922 119.129 91.866 119.497 92.3271 119.497H97.3463C97.8074 119.497 98.1812 119.129 98.1812 118.675V117.161C98.1812 116.707 97.8074 116.339 97.3463 116.339Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.573 116.339H99.5537C99.0926 116.339 98.7188 116.707 98.7188 117.161V118.675C98.7188 119.129 99.0926 119.497 99.5537 119.497H104.573C105.034 119.497 105.408 119.129 105.408 118.675V117.161C105.408 116.707 105.034 116.339 104.573 116.339Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.792 116.339H106.772C106.311 116.339 105.938 116.707 105.938 117.161V118.675C105.938 119.129 106.311 119.497 106.772 119.497H111.792C112.253 119.497 112.627 119.129 112.627 118.675V117.161C112.627 116.707 112.253 116.339 111.792 116.339Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.01 116.339H113.991C113.53 116.339 113.156 116.707 113.156 117.161V118.675C113.156 119.129 113.53 119.497 113.991 119.497H119.01C119.471 119.497 119.845 119.129 119.845 118.675V117.161C119.845 116.707 119.471 116.339 119.01 116.339Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.221 116.339H121.202C120.741 116.339 120.367 116.707 120.367 117.161V118.675C120.367 119.129 120.741 119.497 121.202 119.497H126.221C126.682 119.497 127.056 119.129 127.056 118.675V117.161C127.056 116.707 126.682 116.339 126.221 116.339Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.44 116.339H128.421C127.96 116.339 127.586 116.707 127.586 117.161V118.675C127.586 119.129 127.96 119.497 128.421 119.497H133.44C133.901 119.497 134.275 119.129 134.275 118.675V117.161C134.275 116.707 133.901 116.339 133.44 116.339Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.667 116.339H135.647C135.186 116.339 134.812 116.707 134.812 117.161V118.675C134.812 119.129 135.186 119.497 135.647 119.497H140.667C141.128 119.497 141.502 119.129 141.502 118.675V117.161C141.502 116.707 141.128 116.339 140.667 116.339Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.885 116.339H142.866C142.405 116.339 142.031 116.707 142.031 117.161V118.675C142.031 119.129 142.405 119.497 142.866 119.497H147.885C148.346 119.497 148.72 119.129 148.72 118.675V117.161C148.72 116.707 148.346 116.339 147.885 116.339Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7213 119.941H88.7022C88.241 119.941 87.8672 120.31 87.8672 120.764V122.277C87.8672 122.731 88.241 123.099 88.7022 123.099H93.7213C94.1824 123.099 94.5563 122.731 94.5563 122.277V120.764C94.5563 120.31 94.1824 119.941 93.7213 119.941Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.94 119.941H95.9209C95.4598 119.941 95.0859 120.31 95.0859 120.764V122.277C95.0859 122.731 95.4598 123.099 95.9209 123.099H100.94C101.401 123.099 101.775 122.731 101.775 122.277V120.764C101.775 120.31 101.401 119.941 100.94 119.941Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.167 119.941H103.147C102.686 119.941 102.312 120.31 102.312 120.764V122.277C102.312 122.731 102.686 123.099 103.147 123.099H108.167C108.628 123.099 109.002 122.731 109.002 122.277V120.764C109.002 120.31 108.628 119.941 108.167 119.941Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.385 119.941H110.366C109.905 119.941 109.531 120.31 109.531 120.764V122.277C109.531 122.731 109.905 123.099 110.366 123.099H115.385C115.846 123.099 116.22 122.731 116.22 122.277V120.764C116.22 120.31 115.846 119.941 115.385 119.941Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.612 119.941H117.593C117.132 119.941 116.758 120.31 116.758 120.764V122.277C116.758 122.731 117.132 123.099 117.593 123.099H122.612C123.073 123.099 123.447 122.731 123.447 122.277V120.764C123.447 120.31 123.073 119.941 122.612 119.941Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5729 119.941H81.5537C81.0926 119.941 80.7188 120.31 80.7188 120.764V122.277C80.7188 122.731 81.0926 123.099 81.5537 123.099H86.5729C87.034 123.099 87.4078 122.731 87.4078 122.277V120.764C87.4078 120.31 87.034 119.941 86.5729 119.941Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.815 119.941H124.796C124.335 119.941 123.961 120.31 123.961 120.764V122.277C123.961 122.731 124.335 123.099 124.796 123.099H129.815C130.276 123.099 130.65 122.731 130.65 122.277V120.764C130.65 120.31 130.276 119.941 129.815 119.941Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.034 119.941H132.015C131.554 119.941 131.18 120.31 131.18 120.764V122.277C131.18 122.731 131.554 123.099 132.015 123.099H137.034C137.495 123.099 137.869 122.731 137.869 122.277V120.764C137.869 120.31 137.495 119.941 137.034 119.941Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.26 119.941H139.241C138.78 119.941 138.406 120.31 138.406 120.764V122.277C138.406 122.731 138.78 123.099 139.241 123.099H144.26C144.721 123.099 145.095 122.731 145.095 122.277V120.764C145.095 120.31 144.721 119.941 144.26 119.941Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.131 119.941H146.425C146.213 119.941 146.009 120.024 145.859 120.172C145.709 120.32 145.625 120.52 145.625 120.729V122.312C145.625 122.521 145.709 122.721 145.859 122.869C146.009 123.016 146.213 123.099 146.425 123.099H149.126L149.131 119.941Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.667 119.941H117.647C117.186 119.941 116.812 120.31 116.812 120.764V122.277C116.812 122.731 117.186 123.099 117.647 123.099H122.667C123.128 123.099 123.502 122.731 123.502 122.277V120.764C123.502 120.31 123.128 119.941 122.667 119.941Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1275 123.6H85.1084C84.6473 123.6 84.2734 123.968 84.2734 124.422V125.935C84.2734 126.389 84.6473 126.758 85.1084 126.758H90.1275C90.5887 126.758 90.9625 126.389 90.9625 125.935V124.422C90.9625 123.968 90.5887 123.6 90.1275 123.6Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3463 123.6H92.3271C91.866 123.6 91.4922 123.968 91.4922 124.422V125.935C91.4922 126.389 91.866 126.758 92.3271 126.758H97.3463C97.8074 126.758 98.1812 126.389 98.1812 125.935V124.422C98.1812 123.968 97.8074 123.6 97.3463 123.6Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.573 123.6H99.5537C99.0926 123.6 98.7188 123.968 98.7188 124.422V125.935C98.7188 126.389 99.0926 126.758 99.5537 126.758H104.573C105.034 126.758 105.408 126.389 105.408 125.935V124.422C105.408 123.968 105.034 123.6 104.573 123.6Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.792 123.6H106.772C106.311 123.6 105.938 123.968 105.938 124.422V125.935C105.938 126.389 106.311 126.758 106.772 126.758H111.792C112.253 126.758 112.627 126.389 112.627 125.935V124.422C112.627 123.968 112.253 123.6 111.792 123.6Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.01 123.6H113.991C113.53 123.6 113.156 123.968 113.156 124.422V125.935C113.156 126.389 113.53 126.758 113.991 126.758H119.01C119.471 126.758 119.845 126.389 119.845 125.935V124.422C119.845 123.968 119.471 123.6 119.01 123.6Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.221 123.6H121.202C120.741 123.6 120.367 123.968 120.367 124.422V125.935C120.367 126.389 120.741 126.758 121.202 126.758H126.221C126.682 126.758 127.056 126.389 127.056 125.935V124.422C127.056 123.968 126.682 123.6 126.221 123.6Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.44 123.6H128.421C127.96 123.6 127.586 123.968 127.586 124.422V125.935C127.586 126.389 127.96 126.758 128.421 126.758H133.44C133.901 126.758 134.275 126.389 134.275 125.935V124.422C134.275 123.968 133.901 123.6 133.44 123.6Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.667 123.6H135.647C135.186 123.6 134.812 123.968 134.812 124.422V125.935C134.812 126.389 135.186 126.758 135.647 126.758H140.667C141.128 126.758 141.502 126.389 141.502 125.935V124.422C141.502 123.968 141.128 123.6 140.667 123.6Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.885 123.6H142.866C142.405 123.6 142.031 123.968 142.031 124.422V125.935C142.031 126.389 142.405 126.758 142.866 126.758H147.885C148.346 126.758 148.72 126.389 148.72 125.935V124.422C148.72 123.968 148.346 123.6 147.885 123.6Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7213 127.202H88.7022C88.241 127.202 87.8672 127.57 87.8672 128.024V129.538C87.8672 129.992 88.241 130.36 88.7022 130.36H93.7213C94.1824 130.36 94.5563 129.992 94.5563 129.538V128.024C94.5563 127.57 94.1824 127.202 93.7213 127.202Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.94 127.202H95.9209C95.4598 127.202 95.0859 127.57 95.0859 128.024V129.538C95.0859 129.992 95.4598 130.36 95.9209 130.36H100.94C101.401 130.36 101.775 129.992 101.775 129.538V128.024C101.775 127.57 101.401 127.202 100.94 127.202Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.167 127.202H103.147C102.686 127.202 102.312 127.57 102.312 128.024V129.538C102.312 129.992 102.686 130.36 103.147 130.36H108.167C108.628 130.36 109.002 129.992 109.002 129.538V128.024C109.002 127.57 108.628 127.202 108.167 127.202Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.385 127.202H110.366C109.905 127.202 109.531 127.57 109.531 128.024V129.538C109.531 129.992 109.905 130.36 110.366 130.36H115.385C115.846 130.36 116.22 129.992 116.22 129.538V128.024C116.22 127.57 115.846 127.202 115.385 127.202Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.612 127.202H117.593C117.132 127.202 116.758 127.57 116.758 128.024V129.538C116.758 129.992 117.132 130.36 117.593 130.36H122.612C123.073 130.36 123.447 129.992 123.447 129.538V128.024C123.447 127.57 123.073 127.202 122.612 127.202Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5729 127.202H81.5537C81.0926 127.202 80.7188 127.57 80.7188 128.024V129.538C80.7188 129.992 81.0926 130.36 81.5537 130.36H86.5729C87.034 130.36 87.4078 129.992 87.4078 129.538V128.024C87.4078 127.57 87.034 127.202 86.5729 127.202Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.815 127.202H124.796C124.335 127.202 123.961 127.57 123.961 128.024V129.538C123.961 129.992 124.335 130.36 124.796 130.36H129.815C130.276 130.36 130.65 129.992 130.65 129.538V128.024C130.65 127.57 130.276 127.202 129.815 127.202Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.034 127.202H132.015C131.554 127.202 131.18 127.57 131.18 128.024V129.538C131.18 129.992 131.554 130.36 132.015 130.36H137.034C137.495 130.36 137.869 129.992 137.869 129.538V128.024C137.869 127.57 137.495 127.202 137.034 127.202Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.26 127.202H139.241C138.78 127.202 138.406 127.57 138.406 128.024V129.538C138.406 129.992 138.78 130.36 139.241 130.36H144.26C144.721 130.36 145.095 129.992 145.095 129.538V128.024C145.095 127.57 144.721 127.202 144.26 127.202Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.131 127.202H146.425C146.213 127.202 146.009 127.285 145.859 127.433C145.709 127.581 145.625 127.781 145.625 127.99V129.572C145.627 129.78 145.713 129.978 145.863 130.123C146.012 130.269 146.214 130.351 146.425 130.351H149.126L149.131 127.202Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.667 127.202H117.647C117.186 127.202 116.812 127.57 116.812 128.024V129.538C116.812 129.992 117.186 130.36 117.647 130.36H122.667C123.128 130.36 123.502 129.992 123.502 129.538V128.024C123.502 127.57 123.128 127.202 122.667 127.202Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6041 116.339H21.585C21.1238 116.339 20.75 116.707 20.75 117.161V118.675C20.75 119.129 21.1238 119.497 21.585 119.497H26.6041C27.0652 119.497 27.4391 119.129 27.4391 118.675V117.161C27.4391 116.707 27.0652 116.339 26.6041 116.339Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8229 116.339H28.8037C28.3426 116.339 27.9688 116.707 27.9688 117.161V118.675C27.9688 119.129 28.3426 119.497 28.8037 119.497H33.8229C34.284 119.497 34.6578 119.129 34.6578 118.675V117.161C34.6578 116.707 34.284 116.339 33.8229 116.339Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0494 116.339H36.0303C35.5691 116.339 35.1953 116.707 35.1953 117.161V118.675C35.1953 119.129 35.5691 119.497 36.0303 119.497H41.0494C41.5106 119.497 41.8844 119.129 41.8844 118.675V117.161C41.8844 116.707 41.5106 116.339 41.0494 116.339Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2682 116.339H43.249C42.7879 116.339 42.4141 116.707 42.4141 117.161V118.675C42.4141 119.129 42.7879 119.497 43.249 119.497H48.2682C48.7293 119.497 49.1031 119.129 49.1031 118.675V117.161C49.1031 116.707 48.7293 116.339 48.2682 116.339Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4947 116.339H50.4756C50.0144 116.339 49.6406 116.707 49.6406 117.161V118.675C49.6406 119.129 50.0144 119.497 50.4756 119.497H55.4947C55.9559 119.497 56.3297 119.129 56.3297 118.675V117.161C56.3297 116.707 55.9559 116.339 55.4947 116.339Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1979 119.941H25.1787C24.7176 119.941 24.3438 120.31 24.3438 120.764V122.277C24.3438 122.731 24.7176 123.099 25.1787 123.099H30.1979C30.659 123.099 31.0328 122.731 31.0328 122.277V120.764C31.0328 120.31 30.659 119.941 30.1979 119.941Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4244 119.941H32.4053C31.9441 119.941 31.5703 120.31 31.5703 120.764V122.277C31.5703 122.731 31.9441 123.099 32.4053 123.099H37.4244C37.8856 123.099 38.2594 122.731 38.2594 122.277V120.764C38.2594 120.31 37.8856 119.941 37.4244 119.941Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6432 119.941H39.624C39.1629 119.941 38.7891 120.31 38.7891 120.764V122.277C38.7891 122.731 39.1629 123.099 39.624 123.099H44.6432C45.1043 123.099 45.4781 122.731 45.4781 122.277V120.764C45.4781 120.31 45.1043 119.941 44.6432 119.941Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8697 119.941H46.8506C46.3895 119.941 46.0156 120.31 46.0156 120.764V122.277C46.0156 122.731 46.3895 123.099 46.8506 123.099H51.8697C52.3309 123.099 52.7047 122.731 52.7047 122.277V120.764C52.7047 120.31 52.3309 119.941 51.8697 119.941Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0885 119.941H54.0693C53.6082 119.941 53.2344 120.31 53.2344 120.764V122.277C53.2344 122.731 53.6082 123.099 54.0693 123.099H59.0885C59.5496 123.099 59.9234 122.731 59.9234 122.277V120.764C59.9234 120.31 59.5496 119.941 59.0885 119.941Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0901 119.941H19.8672V123.099H23.0901C23.3018 123.099 23.5047 123.015 23.6542 122.868C23.8037 122.72 23.8876 122.52 23.8876 122.312V120.729C23.8876 120.521 23.8037 120.321 23.6542 120.173C23.5047 120.025 23.3018 119.942 23.0901 119.941Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6041 123.6H21.585C21.1238 123.6 20.75 123.968 20.75 124.422V125.935C20.75 126.389 21.1238 126.758 21.585 126.758H26.6041C27.0652 126.758 27.4391 126.389 27.4391 125.935V124.422C27.4391 123.968 27.0652 123.6 26.6041 123.6Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8229 123.6H28.8037C28.3426 123.6 27.9688 123.968 27.9688 124.422V125.935C27.9688 126.389 28.3426 126.758 28.8037 126.758H33.8229C34.284 126.758 34.6578 126.389 34.6578 125.935V124.422C34.6578 123.968 34.284 123.6 33.8229 123.6Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0494 123.6H36.0303C35.5691 123.6 35.1953 123.968 35.1953 124.422V125.935C35.1953 126.389 35.5691 126.758 36.0303 126.758H41.0494C41.5106 126.758 41.8844 126.389 41.8844 125.935V124.422C41.8844 123.968 41.5106 123.6 41.0494 123.6Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2682 123.6H43.249C42.7879 123.6 42.4141 123.968 42.4141 124.422V125.935C42.4141 126.389 42.7879 126.758 43.249 126.758H48.2682C48.7293 126.758 49.1031 126.389 49.1031 125.935V124.422C49.1031 123.968 48.7293 123.6 48.2682 123.6Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4947 123.6H50.4756C50.0144 123.6 49.6406 123.968 49.6406 124.422V125.935C49.6406 126.389 50.0144 126.758 50.4756 126.758H55.4947C55.9559 126.758 56.3297 126.389 56.3297 125.935V124.422C56.3297 123.968 55.9559 123.6 55.4947 123.6Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1979 127.202H25.1787C24.7176 127.202 24.3438 127.57 24.3438 128.024V129.538C24.3438 129.992 24.7176 130.36 25.1787 130.36H30.1979C30.659 130.36 31.0328 129.992 31.0328 129.538V128.024C31.0328 127.57 30.659 127.202 30.1979 127.202Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4244 127.202H32.4053C31.9441 127.202 31.5703 127.57 31.5703 128.024V129.538C31.5703 129.992 31.9441 130.36 32.4053 130.36H37.4244C37.8856 130.36 38.2594 129.992 38.2594 129.538V128.024C38.2594 127.57 37.8856 127.202 37.4244 127.202Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6432 127.202H39.624C39.1629 127.202 38.7891 127.57 38.7891 128.024V129.538C38.7891 129.992 39.1629 130.36 39.624 130.36H44.6432C45.1043 130.36 45.4781 129.992 45.4781 129.538V128.024C45.4781 127.57 45.1043 127.202 44.6432 127.202Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8697 127.202H46.8506C46.3895 127.202 46.0156 127.57 46.0156 128.024V129.538C46.0156 129.992 46.3895 130.36 46.8506 130.36H51.8697C52.3309 130.36 52.7047 129.992 52.7047 129.538V128.024C52.7047 127.57 52.3309 127.202 51.8697 127.202Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0885 127.202H54.0693C53.6082 127.202 53.2344 127.57 53.2344 128.024V129.538C53.2344 129.992 53.6082 130.36 54.0693 130.36H59.0885C59.5496 130.36 59.9234 129.992 59.9234 129.538V128.024C59.9234 127.57 59.5496 127.202 59.0885 127.202Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0901 127.202H19.8672V130.351H23.0901C23.3018 130.35 23.5047 130.267 23.6542 130.119C23.8037 129.972 23.8876 129.772 23.8876 129.563V127.981C23.8852 127.774 23.8002 127.576 23.6509 127.43C23.5017 127.285 23.3002 127.203 23.0901 127.202Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.261 63.8828H19.7734V115.285H149.261V63.8828Z",
    fill: "white",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.21
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.5536 109.547V104.141L30.5 113.004L31.8168 113.444H46.7222L55.5536 109.547Z",
    fill: "#0E1213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5514 83.9907L20.8828 98.1658V65.8652H55.5514V83.9907Z",
    fill: "#0E1213"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55.5514 65.8643H20.8828V113.443H55.5514V65.8643Z",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.21
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.182 99.0246V95.7031L97.8594 113.004L99.2159 113.444H114.552L148.182 99.0246Z",
    fill: "#0E1213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.182 75.862L84.9141 95.9177V65.8652H148.182V75.862Z",
    fill: "#0E1213"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M148.18 65.8643H84.9141V113.443H148.18V65.8643Z",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4879 63.8828H57.3047V132.349H83.4879V63.8828Z",
    fill: "#0E1213",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8819 95.9943V112.945C76.8819 112.945 81.9174 105.189 82.8787 102.683C83.84 100.177 84.558 97.5306 84.558 97.5306L76.8281 94.7412L76.8819 95.9943Z",
    fill: "#0E1213",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4256 79.3265C84.4256 79.3265 80.073 78.366 79.659 78.5134C79.245 78.6608 76.8828 80.1028 76.8828 80.1028V95.9962C76.8828 95.9962 82.8047 98.3342 83.5999 98.3342C84.3951 98.3342 84.6875 98.2973 84.9495 97.9265C85.2114 97.5556 87.8777 90.24 87.8777 90.24L88.7407 91.6082L93.243 90.7214C93.243 90.7214 92.6045 87.0982 92.5296 86.8057C92.4548 86.5131 92.6045 85.3637 92.2302 84.5138C91.856 83.6638 89.6037 81.9271 88.9559 81.6322C88.308 81.3374 84.4256 79.3265 84.4256 79.3265Z",
    fill: "white",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9922 89.9325L90.1299 86.125",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5547 89.2667C88.5547 89.2667 89.8294 87.8248 90.6596 87.0117",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2129 78.5869C85.2129 78.5869 83.9734 78.5869 83.3723 79.142C82.7712 79.6971 81.2673 83.8364 81.5714 83.9792C81.8754 84.122 84.8738 83.424 84.8738 83.424L85.9637 84.1151C85.9637 84.1151 87.0887 85.9578 87.3132 86.6649C87.5378 87.3721 87.9892 87.1463 87.9892 86.8123C87.9892 86.4784 88.8148 85.223 88.8896 83.2651C88.9644 81.3072 88.7399 80.8995 88.7399 80.8995L85.2129 78.5869Z",
    fill: "white",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9127 78.1074C84.9127 78.1074 84.314 80.1805 84.1994 81.4704C84.0848 82.7603 84.3514 86.1993 84.5759 86.1993C84.8004 86.1993 87.9532 83.2809 88.2526 82.8363C88.5519 82.3917 88.9542 81.6178 88.9542 81.6178C88.9542 81.6178 87.0832 80.989 86.5897 80.3601C86.0962 79.7313 84.9127 78.1074 84.9127 78.1074Z",
    fill: "#9FA6A8",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1484 81.6064L87.3449 83.7417C87.6862 83.4795 87.992 83.1752 88.2547 82.8365C88.5209 82.4492 88.7555 82.0417 88.9564 81.618L87.1484 81.6064Z",
    fill: "#0E1213",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6082 72.3544L85.6118 74.6187C85.6118 74.6187 85.2657 73.8908 84.7441 74.1903C84.2226 74.4897 83.9208 75.5147 84.0425 75.9846C84.091 76.1733 84.1783 76.3501 84.299 76.5042C84.4197 76.6583 84.5712 76.7864 84.7441 76.8806C84.9616 76.9682 84.7441 78.0323 84.7441 78.493C84.7441 78.9537 85.4458 80.5868 86.2199 81.2686C86.9941 81.9504 87.8244 82.2936 88.1705 82.2521C88.5167 82.2107 89.9925 81.7385 90.383 81.3976C90.7659 81.037 91.088 80.6187 91.3373 80.1584C91.4238 79.9464 92.5067 77.4265 92.9417 76.3578C93.3768 75.289 93.5919 74.0935 93.2879 73.1975C92.9838 72.3015 91.5548 71.1889 90.3386 70.9747C89.1224 70.7605 87.7378 70.8895 87.2981 71.2327C86.8584 71.5759 86.6082 72.3544 86.6082 72.3544Z",
    fill: "#9FA6A8",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.336 70.9883C89.1221 70.7764 87.7352 70.9031 87.2955 71.2463C86.8558 71.5895 86.5939 72.3566 86.5939 72.3566L85.6116 74.6208C85.6116 74.6208 85.4385 75.2174 85.7425 75.3118C86.0466 75.4063 86.0887 74.9271 86.1331 74.8005C86.1776 74.6738 86.3062 74.2868 86.3062 74.2868C86.3062 74.2868 87.3025 74.501 87.52 73.9459C87.7376 73.3908 87.0874 72.4925 87.6931 71.6425C88.2989 70.7925 89.9478 71.2993 90.3383 71.8544C90.7289 72.4095 91.206 72.9646 91.8562 72.9646C92.5064 72.9646 93.159 73.2641 93.332 74.0334C93.5051 74.8028 92.6304 75.4431 92.5953 75.9982C92.5696 76.3069 92.5719 76.8413 92.5813 77.2536L92.9415 76.3829C93.3741 75.3141 93.5917 74.1187 93.2876 73.2226C92.9836 72.3266 91.5522 71.2025 90.336 70.9883Z",
    fill: "#0E1213",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.331 76.5848C88.2539 76.8151 88.0972 76.9833 87.9849 76.9464C87.8726 76.9096 87.8399 76.6908 87.9171 76.4535C87.9942 76.2163 88.151 76.0573 88.2656 76.0942C88.3802 76.131 88.4176 76.3499 88.331 76.5848Z",
    fill: "#0E1213",
    stroke: "#0E1213",
    strokeWidth: 0.639581,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.684 77.5479C90.6044 77.7783 90.4501 77.9441 90.3355 77.9073C90.2209 77.8704 90.1928 77.6516 90.27 77.4166C90.3472 77.1817 90.5039 77.0181 90.6161 77.055C90.7284 77.0918 90.7565 77.3107 90.684 77.5479Z",
    fill: "#0E1213",
    stroke: "#0E1213",
    strokeWidth: 0.639581,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.6016 75.2302C88.0933 75.2077 88.581 75.3269 89.0049 75.5734",
    stroke: "#0E1213",
    strokeWidth: 0.639581,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4922 76.135C90.4922 76.135 91.2126 75.8425 91.5868 76.8951",
    stroke: "#0E1213",
    strokeWidth: 0.639581,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4635 77.6025C88.4635 77.6025 87.956 77.8145 88.0215 78.0816C88.0386 78.1358 88.0688 78.1851 88.1095 78.2252C88.1503 78.2654 88.2003 78.2951 88.2553 78.312",
    stroke: "#0E1213",
    strokeWidth: 0.639581,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5469 78.684C89.169 79.1746 89.2672 78.4882 89.2672 78.4882C89.2672 78.4882 89.4427 77.4816 89.5011 77.166",
    stroke: "#0E1213",
    strokeWidth: 0.639581,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0312 78.7549C87.1481 79.0103 87.3163 79.2398 87.5258 79.4295C87.7352 79.6191 87.9815 79.7649 88.2498 79.8582C88.7189 80.0413 89.238 80.0584 89.7186 79.9066",
    stroke: "#0E1213",
    strokeWidth: 0.639581,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5625 90.4483C89.5625 90.4483 91.8171 89.5615 92.4931 89.3749C93.169 89.1884 93.321 89.5247 93.4707 89.7089C93.6204 89.8932 94.0718 91.782 93.9595 92.1505C93.8472 92.5191 93.2836 92.5214 93.2836 92.5214L89.5625 90.4483Z",
    fill: "white",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8578 63.8828H57.5547V132.349H79.8578V63.8828Z",
    fill: "#219EBC",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2406 63.8828H56.9375V132.349H79.2406V63.8828Z",
    fill: "#219EBC",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2031 101.278H77.9803V129.766H58.2031V101.278ZM58.2031 66.4688V94.9572H77.9803V66.4688H58.2031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M58.2031 86.6788L77.9803 75.8781V66.4688H58.2031V86.6788Z",
    fill: "#0E1213"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M70.0234 94.9572L77.9731 91.1542V88.0078L63.6875 94.9572H70.0234Z",
    fill: "#0E1213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2031 101.278H77.9803V129.766H58.2031V101.278ZM58.2031 66.4688V94.9572H77.9803V66.4688H58.2031Z",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M77.9786 126.516V123.008L64.0859 129.766H71.1866L77.9786 126.516Z",
    fill: "#0E1213"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.21
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.2031 125.567L77.9803 115.416V101.277H58.2031V125.567Z",
    fill: "#0E1213"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M76.6487 100.197C77.5981 100.197 78.3678 99.4386 78.3678 98.5035C78.3678 97.5685 77.5981 96.8105 76.6487 96.8105C75.6993 96.8105 74.9297 97.5685 74.9297 98.5035C74.9297 99.4386 75.6993 100.197 76.6487 100.197Z",
    fill: "white",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.6483 98.9347C76.8899 98.9347 77.0857 98.7419 77.0857 98.504C77.0857 98.2661 76.8899 98.0732 76.6483 98.0732C76.4068 98.0732 76.2109 98.2661 76.2109 98.504C76.2109 98.7419 76.4068 98.9347 76.6483 98.9347Z",
    fill: "white",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4009 87.3347C81.4009 87.3347 80.6338 87.7516 80.594 87.9106C80.5542 88.0695 80.3601 88.7859 80.2689 89.1037C80.1777 89.4216 80.6735 89.4239 80.8747 89.1245C81.0552 88.8013 81.204 88.4619 81.319 88.111L81.7868 87.5328C81.7868 87.5328 81.6184 87.1758 81.4009 87.3347Z",
    fill: "#9FA6A8",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9401 89.0837C86.9401 89.0837 84.6878 87.0498 83.8996 86.4233C83.1115 85.7968 81.1515 85.8728 80.2885 85.9096C79.4255 85.9465 79.2758 86.3519 79.5401 86.4993C79.8043 86.6467 80.7843 86.5338 80.9738 86.5338C81.1632 86.5338 82.211 86.6813 82.211 86.6813C82.211 86.6813 80.9363 87.6418 81.0416 87.9366C81.1468 88.2315 81.341 88.676 81.341 88.676C81.4005 88.8842 81.4886 89.0833 81.6029 89.268C81.7175 89.3786 81.5655 89.7125 81.8368 90.0074C82.1081 90.3022 82.3981 90.4519 82.625 90.3391C82.8686 90.2375 83.1186 90.1513 83.3734 90.0811C83.3734 90.0811 84.5428 90.7099 84.9124 90.7468C85.2819 90.7836 85.8128 90.8205 85.8128 90.8205C85.8128 90.8205 89.4544 93.6652 90.6916 94.4046C91.9289 95.144 93.0188 95.144 93.3556 94.9228C93.6923 94.7017 94.1812 94.036 94.0689 93.0018C93.9566 91.9676 93.1334 91.265 92.4551 90.9679C91.7768 90.6708 88.1025 89.7494 86.9401 89.0837Z",
    fill: "#9FA6A8",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3594 88.4689C81.3594 88.4689 82.5498 87.5153 82.7112 87.255C82.8726 86.9947 83.0761 86.8174 83.2164 86.8174",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6094 89.2681C81.6094 89.2681 82.6291 88.7867 82.9916 88.3698C83.3541 87.9529 83.6933 87.8331 83.7985 87.8722",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.516 56.8722H14.3906L20.2634 41.4141H25.8766L20.516 56.8722Z",
    fill: "#219EBC",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.641 56.8722H20.5156L25.8786 41.4141H31.4918L26.641 56.8722Z",
    fill: "white",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.766 56.8722H26.6406L31.4914 41.4141H37.1069L32.766 56.8722Z",
    fill: "#219EBC",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8832 56.8722H32.7578L37.0987 41.4141H42.7119L38.8832 56.8722Z",
    fill: "white",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0082 56.8722H38.8828L42.7138 41.4141H48.327L45.0082 56.8722Z",
    fill: "#219EBC",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1332 56.8722H45.0078L48.3266 41.4141H53.9422L51.1332 56.8722Z",
    fill: "white",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2582 56.8722H51.1328L53.9418 41.4141H59.555L57.2582 56.8722Z",
    fill: "#219EBC",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3754 56.8722H57.25L59.5491 41.4141H65.1623L63.3754 56.8722Z",
    fill: "white",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5004 56.8722H63.375L65.1619 41.4141H70.7751L69.5004 56.8722Z",
    fill: "#219EBC",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6254 56.8722H69.5L70.777 41.4141H76.3902L75.6254 56.8722Z",
    fill: "white",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7504 56.8722H75.625L76.3898 41.4141H82.0053L81.7504 56.8722Z",
    fill: "#219EBC",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8676 56.8722H81.7422L81.9971 41.4141H87.6103L87.8676 56.8722Z",
    fill: "white",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9897 56.8722H87.8643L87.6094 41.4141H93.2226L93.9897 56.8722Z",
    fill: "#219EBC",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.117 56.8722H93.9937L93.2266 41.4141H98.8421L100.117 56.8722Z",
    fill: "white",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.238 56.8722H100.113L98.8359 41.4141H104.449L106.238 56.8722Z",
    fill: "#219EBC",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.365 56.8722H106.24L104.453 41.4141H110.066L112.365 56.8722Z",
    fill: "white",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.485 56.8722H112.362L110.062 41.4141H115.676L118.485 56.8722Z",
    fill: "#219EBC",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.604 56.8722H118.481L115.672 41.4141H121.285L124.604 56.8722Z",
    fill: "white",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.725 56.8722H124.602L121.281 41.4141H126.897L130.725 56.8722Z",
    fill: "#219EBC",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.853 56.8722H130.729L126.898 41.4141H132.512L136.853 56.8722Z",
    fill: "white",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.972 56.8722H136.849L132.508 41.4141H138.121L142.972 56.8722Z",
    fill: "#219EBC",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.101 56.8722H142.976L138.125 41.4141H143.741L149.101 56.8722Z",
    fill: "white",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.22 56.8722H149.095L143.734 41.4141H149.348L155.22 56.8722Z",
    fill: "#219EBC",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3906 56.873H20.516V58.9461C20.516 59.711 20.2075 60.4445 19.6584 60.9853C19.1092 61.5261 18.3644 61.83 17.5878 61.83H17.3188C16.5422 61.83 15.7974 61.5261 15.2483 60.9853C14.6991 60.4445 14.3906 59.711 14.3906 58.9461V56.873Z",
    fill: "#219EBC",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5156 56.873H26.641V58.9461C26.641 59.711 26.3325 60.4445 25.7834 60.9853C25.2342 61.5261 24.4894 61.83 23.7128 61.83H23.4438C22.6672 61.83 21.9224 61.5261 21.3733 60.9853C20.8241 60.4445 20.5156 59.711 20.5156 58.9461V56.873Z",
    fill: "#C2C5C6",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6406 56.873H32.759V58.9461C32.759 59.3248 32.6833 59.6998 32.5361 60.0497C32.389 60.3996 32.1733 60.7175 31.9014 60.9853C31.6295 61.2531 31.3066 61.4655 30.9514 61.6104C30.5961 61.7554 30.2153 61.83 29.8308 61.83H29.5618C28.7864 61.8281 28.0434 61.5235 27.4958 60.9829C26.9482 60.4422 26.6406 59.7098 26.6406 58.9461V56.873Z",
    fill: "#219EBC",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7578 56.873H38.8832V58.9461C38.8832 59.711 38.5747 60.4445 38.0256 60.9853C37.4764 61.5261 36.7316 61.83 35.955 61.83H35.686C34.9094 61.83 34.1646 61.5261 33.6155 60.9853C33.0663 60.4445 32.7578 59.711 32.7578 58.9461V56.873Z",
    fill: "#C2C5C6",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8828 56.873H45.0082V58.9461C45.0082 59.711 44.6997 60.4445 44.1506 60.9853C43.6014 61.5261 42.8566 61.83 42.08 61.83H41.811C41.0344 61.83 40.2896 61.5261 39.7405 60.9853C39.1913 60.4445 38.8828 59.711 38.8828 58.9461V56.873Z",
    fill: "#219EBC",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0078 56.873H51.1332V58.9461C51.1338 59.3262 51.0582 59.7026 50.9106 60.0538C50.7629 60.405 50.5463 60.7239 50.2731 60.9924C49.9999 61.2608 49.6755 61.4734 49.3186 61.6179C48.9616 61.7625 48.5792 61.8361 48.1933 61.8346H47.936C47.5511 61.8346 47.1699 61.7598 46.8144 61.6146C46.4588 61.4694 46.1358 61.2566 45.8638 60.9883C45.5918 60.72 45.3763 60.4015 45.2294 60.0511C45.0825 59.7007 45.0072 59.3252 45.0078 58.9461V56.873Z",
    fill: "#C2C5C6",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1328 56.873H57.2582V58.9461C57.2582 59.711 56.9497 60.4445 56.4006 60.9853C55.8514 61.5261 55.1066 61.83 54.33 61.83H54.061C53.2844 61.83 52.5396 61.5261 51.9905 60.9853C51.4413 60.4445 51.1328 59.711 51.1328 58.9461V56.873Z",
    fill: "#219EBC",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.25 56.873H63.3754V58.9461C63.3754 59.711 63.0669 60.4445 62.5178 60.9853C61.9686 61.5261 61.2238 61.83 60.4472 61.83H60.1782C59.7937 61.83 59.4129 61.7554 59.0576 61.6104C58.7024 61.4655 58.3796 61.2531 58.1077 60.9853C57.8357 60.7175 57.6201 60.3996 57.4729 60.0497C57.3257 59.6998 57.25 59.3248 57.25 58.9461V56.873Z",
    fill: "#C2C5C6",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.375 56.873H69.5004V58.9461C69.5004 59.711 69.1919 60.4445 68.6427 60.9853C68.0936 61.5261 67.3488 61.83 66.5722 61.83H66.3032C65.9187 61.83 65.5379 61.7554 65.1826 61.6104C64.8274 61.4655 64.5046 61.2531 64.2327 60.9853C63.9607 60.7175 63.745 60.3996 63.5979 60.0497C63.4507 59.6998 63.375 59.3248 63.375 58.9461V56.873Z",
    fill: "#219EBC",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5 56.873H75.6254V58.9461C75.6254 59.711 75.3169 60.4445 74.7678 60.9853C74.2186 61.5261 73.4738 61.83 72.6972 61.83H72.4282C71.6516 61.83 70.9068 61.5261 70.3577 60.9853C69.8085 60.4445 69.5 59.711 69.5 58.9461V56.873Z",
    fill: "#C2C5C6",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.625 56.873H81.7504V58.9461C81.7504 59.711 81.4419 60.4445 80.8928 60.9853C80.3436 61.5261 79.5988 61.83 78.8222 61.83H78.5532C78.1687 61.83 77.7879 61.7554 77.4326 61.6104C77.0774 61.4655 76.7546 61.2531 76.4827 60.9853C76.2107 60.7175 75.9951 60.3996 75.8479 60.0497C75.7007 59.6998 75.625 59.3248 75.625 58.9461V56.873Z",
    fill: "#219EBC",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7422 56.873H87.8676V58.9461C87.8676 59.711 87.5591 60.4445 87.0099 60.9853C86.4608 61.5261 85.716 61.83 84.9394 61.83H84.6751C84.2902 61.8306 83.9089 61.7564 83.5531 61.6118C83.1973 61.4671 82.8739 61.2548 82.6015 60.9869C82.3291 60.7191 82.113 60.401 81.9655 60.0508C81.8181 59.7006 81.7422 59.3252 81.7422 58.9461V56.873Z",
    fill: "#C2C5C6",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8672 56.873H93.9926V58.9461C93.9926 59.711 93.6841 60.4445 93.1349 60.9853C92.5858 61.5261 91.841 61.83 91.0644 61.83H90.7954C90.0188 61.83 89.274 61.5261 88.7248 60.9853C88.1757 60.4445 87.8672 59.711 87.8672 58.9461V56.873Z",
    fill: "#219EBC",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9922 56.873H100.115V58.9461C100.115 59.711 99.8067 60.4445 99.2576 60.9853C98.7085 61.5261 97.9636 61.83 97.187 61.83H96.9181C96.1419 61.8293 95.3977 61.5252 94.849 60.9845C94.3004 60.4437 93.9922 59.7106 93.9922 58.9461V56.873Z",
    fill: "#C2C5C6",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.117 56.873H106.243V58.9461C106.243 59.711 105.934 60.4445 105.385 60.9853C104.836 61.5261 104.091 61.83 103.314 61.83H103.045C102.661 61.83 102.28 61.7554 101.925 61.6104C101.57 61.4655 101.247 61.2531 100.975 60.9853C100.703 60.7175 100.487 60.3996 100.34 60.0497C100.193 59.6998 100.117 59.3248 100.117 58.9461V56.873Z",
    fill: "#219EBC",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.234 56.873H112.36V58.9461C112.36 59.711 112.051 60.4445 111.502 60.9853C110.953 61.5261 110.208 61.83 109.432 61.83H109.163C108.386 61.83 107.641 61.5261 107.092 60.9853C106.543 60.4445 106.234 59.711 106.234 58.9461V56.873Z",
    fill: "#C2C5C6",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.359 56.873H118.485V58.9461C118.485 59.3258 118.41 59.7019 118.263 60.0527C118.115 60.4036 117.899 60.7224 117.626 60.9907C117.354 61.2591 117.03 61.4718 116.673 61.6166C116.317 61.7614 115.935 61.8355 115.55 61.8346H115.281C114.504 61.8327 113.761 61.5275 113.213 60.9858C112.665 60.4442 112.358 59.7106 112.359 58.9461V56.873Z",
    fill: "#219EBC",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.484 56.873H124.61V58.9461C124.61 59.711 124.301 60.4445 123.752 60.9853C123.203 61.5261 122.458 61.83 121.682 61.83H121.413C121.028 61.83 120.647 61.7554 120.292 61.6104C119.937 61.4655 119.614 61.2531 119.342 60.9853C119.07 60.7175 118.854 60.3996 118.707 60.0497C118.56 59.6998 118.484 59.3248 118.484 58.9461V56.873Z",
    fill: "#C2C5C6",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.609 56.873H130.732V58.9461C130.732 59.711 130.424 60.4445 129.875 60.9853C129.326 61.5261 128.581 61.83 127.804 61.83H127.535C126.759 61.8293 126.015 61.5252 125.466 60.9845C124.918 60.4437 124.609 59.7106 124.609 58.9461V56.873Z",
    fill: "#219EBC",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.727 56.873H136.852V58.9461C136.852 59.711 136.543 60.4445 135.994 60.9853C135.445 61.5261 134.7 61.83 133.924 61.83H133.655C133.27 61.83 132.889 61.7554 132.534 61.6104C132.179 61.4655 131.856 61.2531 131.584 60.9853C131.312 60.7175 131.097 60.3996 130.949 60.0497C130.802 59.6998 130.727 59.3248 130.727 58.9461V56.873Z",
    fill: "#C2C5C6",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.852 56.873H142.977V58.9461C142.977 59.711 142.668 60.4445 142.119 60.9853C141.57 61.5261 140.825 61.83 140.049 61.83H139.78C139.003 61.83 138.258 61.5261 137.709 60.9853C137.16 60.4445 136.852 59.711 136.852 58.9461V56.873Z",
    fill: "#219EBC",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.977 56.873H149.102V58.9461C149.102 59.711 148.793 60.4445 148.244 60.9853C147.695 61.5261 146.95 61.83 146.174 61.83H145.905C145.128 61.83 144.383 61.5261 143.834 60.9853C143.285 60.4445 142.977 59.711 142.977 58.9461V56.873Z",
    fill: "#C2C5C6",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.094 56.873H155.219V58.9461C155.219 59.711 154.911 60.4445 154.362 60.9853C153.812 61.5261 153.068 61.83 152.291 61.83H152.034C151.648 61.8315 151.266 61.758 150.909 61.6138C150.553 61.4695 150.229 61.2573 149.956 60.9894C149.682 60.7214 149.466 60.403 149.318 60.0524C149.17 59.7017 149.094 59.3258 149.094 58.9461V56.873Z",
    fill: "#219EBC",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4375 79.2478L68.1102 74.7539L74.7361 79.2478",
    stroke: "white",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.777 74.7535C68.777 74.3044 68.4869 73.9404 68.1268 73.9404C67.7666 73.9404 67.4766 74.3044 67.4766 74.7535C67.4766 75.2027 67.7666 75.5689 68.1268 75.5689C68.4869 75.5689 68.777 75.205 68.777 74.7535Z",
    fill: "white",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3006 77.9785H59.875V91.2945H76.3006V77.9785Z",
    fill: "white",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.142 82.8243L62.6953 79.6963H63.1818L63.4437 81.7233L63.7735 79.7032H64.1688L64.5056 81.7233L64.7652 79.6963H65.2446L64.8003 82.8243H64.3325L63.9793 80.7282L63.6308 82.8243H63.142Z",
    fill: "#0E1213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5859 82.8243V79.6963H66.9191V80.0971H66.1683V80.9977H66.76V81.3962H66.1683V82.4396H66.9284V82.8335L65.5859 82.8243Z",
    fill: "#0E1213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0703 82.8243L68.7041 79.6963H69.3239L69.9414 82.8243H69.4035L69.2772 82.101H68.7252L68.5966 82.8243H68.0703ZM68.8024 81.7394H69.2327L69.0175 80.4265L68.8024 81.7394Z",
    fill: "#0E1213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.25 82.8248V79.6968H71.0101C71.194 79.6924 71.3774 79.7181 71.5527 79.7728C71.6916 79.8171 71.8106 79.9074 71.8895 80.0285C71.9749 80.1795 72.0154 80.3511 72.0065 80.5237C72.0082 80.6376 71.9956 80.7514 71.969 80.8623C71.9491 80.9559 71.9083 81.044 71.8498 81.1203C71.7876 81.194 71.707 81.2503 71.6159 81.2838L72.0579 82.8248H71.4779L71.0943 81.3921H70.83V82.8248H70.25ZM70.83 81.0327H71.0101C71.1023 81.0365 71.1942 81.0199 71.2791 80.9844C71.3444 80.9521 71.3953 80.8971 71.4218 80.83C71.4525 80.7427 71.4668 80.6506 71.4639 80.5582C71.4727 80.434 71.4425 80.3102 71.3773 80.2035C71.3343 80.1596 71.2814 80.1261 71.223 80.1057C71.1645 80.0853 71.1021 80.0786 71.0405 80.086H70.83V81.0327Z",
    fill: "#0E1213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4453 82.8243V79.6963H73.7785V80.0971H73.0253V80.9977H73.6171V81.3962H73.0253V82.4396H73.7855V82.8335L72.4453 82.8243Z",
    fill: "#0E1213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0065 83.6655C63.643 83.4879 63.2428 83.3955 62.837 83.3955C62.4313 83.3955 62.0311 83.4879 61.6676 83.6655C61.3592 83.8501 61.124 84.1329 61.0011 84.4671C60.8742 84.8244 60.8132 85.2012 60.821 85.5796V87.7264C60.8138 88.1071 60.8748 88.486 61.0011 88.8458C61.1203 89.1855 61.3538 89.4749 61.6629 89.6659C62.0247 89.8489 62.4256 89.9444 62.8324 89.9444C63.2391 89.9444 63.64 89.8489 64.0018 89.6659C64.3053 89.4729 64.5361 89.1873 64.659 88.8528C64.7872 88.4957 64.849 88.1189 64.8414 87.7402V85.5865C64.8496 85.2071 64.7878 84.8294 64.659 84.4717C64.5399 84.1382 64.31 83.8542 64.0065 83.6655ZM63.1037 85.3355V87.9798C63.104 88.1013 63.0915 88.2225 63.0662 88.3414C63.0591 88.3929 63.0362 88.4411 63.0008 88.4796C62.9483 88.5011 62.8913 88.5098 62.8347 88.5049C62.7037 88.5049 62.6686 88.4773 62.6686 88.475C62.633 88.4415 62.6107 88.3966 62.6055 88.3483C62.5831 88.2267 62.5722 88.1033 62.5728 87.9798V85.3355C62.5712 85.214 62.583 85.0928 62.6078 84.9738C62.6147 84.9281 62.637 84.8859 62.671 84.8541C62.7215 84.8289 62.7783 84.8185 62.8347 84.8241C62.8921 84.8187 62.95 84.8274 63.0031 84.8495C63.0385 84.8825 63.0615 84.9263 63.0686 84.9738C63.0934 85.0928 63.1052 85.214 63.1037 85.3355Z",
    fill: "#0E1213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9733 83.4609V85.4465L73.1126 83.4609H68.7343V84.6126C68.7132 84.5458 68.6898 84.479 68.6641 84.4168C68.5425 84.1177 68.3238 83.8666 68.042 83.7028C67.7279 83.5362 67.3739 83.4566 67.0176 83.4725H64.9688V89.8736H66.7065V87.3122H66.9404C67.2707 87.3191 67.5986 87.2554 67.9016 87.1256C68.2004 86.9937 68.447 86.7687 68.6033 86.4853C68.6552 86.3898 68.6975 86.2895 68.7296 86.1859V89.8713H73.3886V87.7982L74.2516 89.8713H75.5169V83.4609H73.9733ZM67.1719 85.4142C67.1779 85.5424 67.1629 85.6708 67.1275 85.7943C67.1237 85.8097 67.1167 85.8241 67.1071 85.8368C67.0974 85.8494 67.0853 85.8601 67.0714 85.868C66.9767 85.9035 66.8754 85.9185 66.7743 85.9118H66.7065V84.8591H66.7743C66.8801 84.8495 66.9866 84.8645 67.0854 84.9029C67.0971 84.9029 67.1205 84.9236 67.1345 84.9835C67.1634 85.1252 67.1759 85.2697 67.1719 85.4142ZM70.4697 88.4777V87.2408H71.5572V85.8588H70.4697V84.8683H71.8145V88.487L70.4697 88.4777Z",
    fill: "#0E1213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8349 89.6087C62.4905 89.6248 62.1484 89.5449 61.8479 89.3784C61.6034 89.2257 61.4188 88.9959 61.324 88.7265C61.2107 88.403 61.1568 88.0621 61.165 87.72V85.5732C61.1562 85.234 61.2101 84.896 61.324 84.5758C61.42 84.3119 61.6049 84.0883 61.8479 83.9424C62.1581 83.7983 62.4967 83.7236 62.8396 83.7236C63.1825 83.7236 63.5211 83.7983 63.8313 83.9424C64.0731 84.0902 64.2582 84.3131 64.3575 84.5758C64.4723 84.8959 64.527 85.2338 64.5189 85.5732V87.7384C64.5262 88.0769 64.4715 88.414 64.3575 88.7334C64.2589 89.002 64.0741 89.2316 63.8313 89.3876C63.5268 89.5521 63.1815 89.6287 62.8349 89.6087ZM62.8349 88.8371C62.9749 88.8494 63.1144 88.8091 63.2255 88.7242C63.3142 88.6399 63.3738 88.5304 63.3962 88.411C63.4254 88.2692 63.4395 88.1249 63.4383 87.9802V85.3359C63.4398 85.1905 63.4257 85.0454 63.3962 84.9029C63.3734 84.7876 63.3135 84.6827 63.2255 84.6035C63.1101 84.5314 62.9763 84.4931 62.8396 84.4931C62.7029 84.4931 62.5691 84.5314 62.4537 84.6035C62.3634 84.6813 62.3025 84.7868 62.2806 84.9029C62.2503 85.0453 62.2354 85.1904 62.2362 85.3359V87.9802C62.2355 88.1247 62.2488 88.269 62.2759 88.411C62.2837 88.4753 62.3044 88.5375 62.3368 88.5939C62.3693 88.6502 62.4128 88.6997 62.4648 88.7394C62.5168 88.779 62.5763 88.8081 62.6399 88.8249C62.7034 88.8416 62.7697 88.8458 62.8349 88.8371Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3047 89.5329V83.7905H67.0167C67.3135 83.7781 67.6082 83.8442 67.8704 83.9817C68.0883 84.111 68.2574 84.3067 68.3522 84.5391C68.4617 84.8204 68.5142 85.1202 68.5065 85.4213C68.5207 85.7337 68.4539 86.0444 68.3124 86.3243C68.1926 86.5454 68.0018 86.7212 67.7698 86.8241C67.5099 86.9336 67.2292 86.987 66.9465 86.9807H66.3712V89.5329H65.3047ZM66.3712 86.2437H66.7735C66.9274 86.2506 67.081 86.223 67.2225 86.163C67.3325 86.1091 67.4165 86.0148 67.4564 85.9004C67.5014 85.7424 67.5219 85.5785 67.5172 85.4144C67.5206 85.2443 67.5049 85.0744 67.4704 84.9077C67.4583 84.8488 67.4342 84.793 67.3996 84.7436C67.3651 84.6941 67.3208 84.652 67.2693 84.6198C67.1176 84.5493 66.9503 84.5176 66.7828 84.5276H66.3805L66.3712 86.2437Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0703 89.5324V83.79H71.5191V84.5271H70.1368V86.1787H71.222V86.9088H70.1368V88.8091H71.5401V89.5324H69.0703Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1484 89.5324V83.79H72.8899L74.3072 87.0655V83.79H75.1866V89.5324H74.4849L73.0606 86.1004V89.5324H72.1484Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.861 100.079L158.025 100.795L161.32 95.9117C161.379 95.5915 161.428 95.2668 161.47 94.9374L161.608 90.6899C161.608 90.6899 159.688 92.3806 159.437 92.4428C159.187 92.505 160.787 86.7027 161.18 85.2654C161.061 84.1874 160.918 83.0495 160.759 81.8702L158.355 82.9551L160.19 80.2809L159.517 74.5892L158.266 75.0498L159.171 72.3572C158.773 70.3762 158.338 68.4161 157.866 66.5549L156.668 63.7263L156.074 66.0873L155.99 60.3288C154.601 56.4937 153.031 53.8954 151.371 53.7941C149.366 53.672 147.5 57.2031 145.926 62.19L145.884 65.47L145.463 63.7194C144.651 66.5388 143.926 69.7083 143.313 72.9054L143.72 74.1538L143.133 73.8705C142.766 75.8606 142.432 77.8416 142.17 79.7373L143.643 82.0614L141.983 81.1032C141.735 82.9459 141.538 84.6919 141.398 86.2421C141.985 88.5132 142.724 91.4639 142.567 91.4086C142.411 91.3533 141.723 90.6945 141.164 90.144C141.164 90.3536 141.164 90.5586 141.164 90.7498C141.162 92.7307 141.42 94.7036 141.934 96.6189L144.008 99.9358L142.892 99.3645C144.735 103.594 147.872 106.505 151.432 106.717C155.033 106.947 158.198 104.351 160.024 100.267L159.861 100.079Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.139 89.2383L150.76 91.4979L150.481 98.0972L148.596 96.7266L150.425 99.4608L149.99 128.613H152.004L151.73 94.5131L157.159 91.9079L154.055 92.8454L154.677 91.0511L153.194 93.1057L151.712 93.5525L151.602 87.5246L156.99 80.824L154.102 83.4821L154.588 81.5403L153.208 84.3044L151.569 85.8131L151.396 76.3945L150.82 90.079L145.703 84.4518L148.514 88.3699L145.867 87.9184L149.139 89.2383Z",
    fill: "#0E1213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.033 76.7705C157.033 76.7705 157.129 77.6919 156.614 78.3483C156.1 79.0048 155.171 79.1131 155.171 79.1131C155.171 79.1131 155.075 78.1917 155.59 77.5375C156.104 76.8834 157.033 76.7705 157.033 76.7705Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.129 81.2207C160.129 81.2207 160.222 82.1421 159.708 82.7962C159.193 83.4504 158.265 83.5633 158.265 83.5633C158.265 83.5633 158.169 82.6419 158.684 81.9854C159.198 81.329 160.129 81.2207 160.129 81.2207Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.136 89.5158C159.989 90.0473 159.658 90.5117 159.2 90.8287C158.482 91.2525 157.547 91.059 157.547 91.059C157.547 91.059 157.781 90.1699 158.482 89.7461C159.184 89.3223 160.136 89.5158 160.136 89.5158Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.156 88.4768C143.311 89.0393 143.643 89.5392 144.103 89.9049C144.594 90.2186 145.173 90.3688 145.757 90.3334C145.604 89.7729 145.277 89.2736 144.821 88.9053C144.328 88.5879 143.744 88.4375 143.156 88.4768Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.564 85.8525C156.564 85.8525 156.66 86.7739 156.145 87.4304C155.631 88.0868 154.702 88.1951 154.702 88.1951C154.702 88.1951 154.606 87.2737 155.121 86.6196C155.636 85.9654 156.564 85.8525 156.564 85.8525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.754 72.0576C155.754 72.0576 155.849 72.979 155.335 73.6354C154.82 74.2919 153.89 74.4002 153.89 74.4002C153.89 74.4002 153.796 73.4788 154.308 72.8223C154.82 72.1659 155.754 72.0576 155.754 72.0576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.917 75.4805C153.917 75.4805 154.013 76.4018 153.499 77.056C152.984 77.7102 152.046 77.8345 152.046 77.8345C152.046 77.8345 151.95 76.9132 152.465 76.2567C152.979 75.6002 153.917 75.4805 153.917 75.4805Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.283 73.1748C158.283 73.1748 158.379 74.0962 157.864 74.7503C157.35 75.4045 156.421 75.5174 156.421 75.5174C156.421 75.5174 156.325 74.596 156.84 73.9395C157.354 73.2831 158.283 73.1748 158.283 73.1748Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.078 72.3066C144.034 72.8801 144.182 73.4518 144.499 73.9351C144.869 74.3902 145.374 74.7197 145.944 74.8772C145.986 74.3039 145.838 73.7326 145.523 73.2487C145.153 72.7941 144.647 72.4648 144.078 72.3066Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.145 67.7617C156.145 67.7617 156.238 68.6831 155.726 69.3395C155.214 69.996 154.281 70.1043 154.281 70.1043C154.281 70.1043 154.185 69.1829 154.699 68.5264C155.214 67.87 156.145 67.7617 156.145 67.7617Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.238 63.1172C155.238 63.1172 155.568 64.0109 155.238 64.7733C154.993 65.2672 154.579 65.6603 154.068 65.8836C154.068 65.8836 153.739 64.9922 154.068 64.2297C154.315 63.7359 154.728 63.3424 155.238 63.1172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.755 61.5195C149.259 61.8263 149.654 62.2793 149.887 62.8163C150.052 63.3579 150.029 63.9384 149.821 64.4656C149.316 64.1605 148.919 63.7081 148.687 63.1711C148.521 62.6286 148.545 62.0471 148.755 61.5195Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.777 67.1934C151.777 67.1934 152.374 67.9512 152.327 68.7919C152.264 69.3438 152.007 69.8565 151.599 70.2408C151.599 70.2408 151.001 69.4852 151.05 68.6422C151.113 68.0905 151.371 67.578 151.777 67.1934Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.611 59.0137C151.611 59.0137 152.209 59.7715 152.16 60.6261C152.097 61.1768 151.841 61.6885 151.435 62.0726C151.435 62.0726 150.837 61.3171 150.886 60.474C150.946 59.9186 151.203 59.4018 151.611 59.0137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.843 76.0244C144.801 76.5981 144.95 77.1695 145.266 77.6529C145.636 78.108 146.142 78.4374 146.712 78.595C146.753 78.0216 146.606 77.4504 146.291 76.9665C145.919 76.5116 145.413 76.1822 144.843 76.0244Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.085 80.9443C143.043 81.5177 143.191 82.0889 143.506 82.5728C143.876 83.0274 144.382 83.3568 144.951 83.5149C144.995 82.9415 144.847 82.3697 144.53 81.8864C144.16 81.4314 143.655 81.1019 143.085 80.9443Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.757 83.0547C147.715 83.628 147.863 84.1993 148.178 84.6832C148.548 85.1389 149.053 85.4691 149.623 85.6276C149.667 85.0541 149.519 84.4824 149.202 83.9991C148.833 83.5429 148.327 83.2126 147.757 83.0547Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.034 76.166C148.825 76.6932 148.803 77.2741 148.971 77.8152C149.204 78.3526 149.601 78.805 150.107 79.1098C150.315 78.5824 150.337 78.0018 150.171 77.4605C149.937 76.9237 149.54 76.4715 149.034 76.166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.727 94.5007C145.727 94.5007 146.674 94.5767 147.319 94.0561C147.965 93.5355 148.068 92.6211 148.068 92.6211C148.068 92.6211 147.132 92.5451 146.475 93.0633C145.818 93.5816 145.727 94.5007 145.727 94.5007Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.82 94.0413C154.995 94.5984 155.341 95.088 155.812 95.4418C156.31 95.7409 156.894 95.8734 157.475 95.8196C157.301 95.2628 156.955 94.7732 156.486 94.4191C155.987 94.1192 155.402 93.9866 154.82 94.0413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.772 71.5068C146.731 72.0805 146.879 72.652 147.196 73.1353C147.565 73.5915 148.071 73.9218 148.641 74.0797C148.683 73.5061 148.534 72.9346 148.218 72.4512C147.848 71.9951 147.343 71.6647 146.772 71.5068Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.757 67.4238C146.715 67.9972 146.863 68.5684 147.178 69.0523C147.548 69.5069 148.054 69.8363 148.623 69.9944C148.665 69.4211 148.517 68.8498 148.202 68.3659C147.832 67.9108 147.327 67.5814 146.757 67.4238Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.273 127.992H143.18V132.544H159.273V127.992Z",
    fill: "#9FA6A8",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5365 100.079L24.6981 100.795L27.9959 95.9117C28.052 95.5916 28.1011 95.2668 28.1456 94.9374L28.2812 90.6899C28.2812 90.6899 26.3611 92.3806 26.1108 92.4428C25.8605 92.505 27.4626 86.7027 27.8556 85.2654C27.7339 84.1874 27.5936 83.0495 27.4322 81.8702L25.0186 82.9551L26.8522 80.2809L26.181 74.5892L24.9273 75.0498L25.8348 72.3572C25.4372 70.3762 24.9999 68.4161 24.5297 66.5549L23.3323 63.7263L22.7476 66.0873L22.6657 60.3288C21.2624 56.4937 19.7047 53.8954 18.0465 53.7941C16.0421 53.672 14.1757 57.2031 12.6017 62.19L12.5573 65.47L12.1386 63.7194C11.327 66.5388 10.602 69.7083 9.98921 72.9054L10.3938 74.1492L9.80678 73.8659C9.43958 75.856 9.10513 77.837 8.84318 79.7327L10.3096 82.0568L8.64672 81.1032C8.3988 82.9459 8.2 84.6919 8.06201 86.2421C8.64906 88.5132 9.38579 91.4639 9.23143 91.4086C9.07706 91.3533 8.38945 90.6945 7.82813 90.144C7.82813 90.3536 7.82813 90.5586 7.82813 90.7498C7.82748 92.7307 8.0869 94.7034 8.59994 96.6189L10.6675 99.9473L9.55185 99.376C11.3925 103.605 14.5312 106.517 18.0909 106.728C21.6927 106.959 24.8572 104.363 26.6815 100.279L26.5365 100.079Z",
    fill: "#219EBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8029 89.2383L17.4261 91.4979L17.1478 98.0972L15.2603 96.7266L17.0893 99.4608L16.6566 128.613H18.6703L18.3944 94.5131L23.8251 91.9079L20.7215 92.8454L21.3413 91.0511L19.8585 93.1057L18.378 93.5525L18.2657 87.5246L23.6544 80.824L20.7659 83.4821L21.2548 81.5403L19.8725 84.3044L18.2353 85.8131L18.0623 76.3945L17.4846 90.079L12.3672 84.4518L15.1808 88.3699L12.5309 87.9184L15.8029 89.2383Z",
    fill: "#0E1213"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7066 76.7705C23.7066 76.7705 23.8025 77.6919 23.288 78.3483C22.7734 79.0048 21.8426 79.1131 21.8426 79.1131C21.8426 79.1131 21.749 78.1917 22.2636 77.5375C22.7781 76.8834 23.7066 76.7705 23.7066 76.7705Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7985 81.2207C26.7985 81.2207 26.8944 82.1421 26.3798 82.7962C25.8653 83.4504 24.9368 83.5633 24.9368 83.5633C24.9368 83.5633 24.8409 82.6419 25.3554 81.9854C25.87 81.329 26.7985 81.2207 26.7985 81.2207Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8078 89.5158C26.6597 90.0468 26.329 90.5109 25.8723 90.8287C25.1543 91.2525 24.2188 91.059 24.2188 91.059C24.2188 91.059 24.4526 90.1699 25.1543 89.7461C25.8559 89.3223 26.8078 89.5158 26.8078 89.5158Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.84375 88.476C9.99731 89.0362 10.3243 89.5354 10.7793 89.9041C11.2696 90.2178 11.8493 90.368 12.4328 90.3325C12.281 89.7715 11.9537 89.2719 11.4973 88.9044C11.0073 88.5901 10.4274 88.4399 9.84375 88.476Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2305 85.8525C23.2305 85.8525 23.3264 86.7739 22.8118 87.4304C22.2973 88.0868 21.3664 88.1951 21.3664 88.1951C21.3664 88.1951 21.2706 87.2737 21.7851 86.6196C22.2996 85.9654 23.2305 85.8525 23.2305 85.8525Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4258 72.0576C22.4258 72.0576 22.5194 72.979 22.0048 73.6354C21.4903 74.2919 20.5618 74.4002 20.5618 74.4002C20.5618 74.4002 20.4659 73.4788 20.9804 72.8223C21.495 72.1659 22.4258 72.0576 22.4258 72.0576Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5782 75.4805C20.5782 75.4805 20.6741 76.4018 20.1595 77.056C19.645 77.7102 18.7258 77.8345 18.7258 77.8345C18.7258 77.8345 18.6299 76.9132 19.1445 76.2567C19.659 75.6002 20.5782 75.4805 20.5782 75.4805Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9492 73.1748C24.9492 73.1748 25.0451 74.0962 24.5306 74.7503C24.0161 75.4045 23.0852 75.5174 23.0852 75.5174C23.0852 75.5174 22.9893 74.596 23.5038 73.9395C24.0184 73.2831 24.9492 73.1748 24.9492 73.1748Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7413 72.3066C10.6995 72.88 10.8472 73.4513 11.1623 73.9351C11.5335 74.39 12.0396 74.7194 12.6101 74.8772C12.6495 74.3018 12.4976 73.7293 12.1774 73.2464C11.8095 72.7938 11.3075 72.4653 10.7413 72.3066Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8141 67.7617C22.8141 67.7617 22.91 68.6831 22.3954 69.3395C21.8809 69.996 20.9524 70.1043 20.9524 70.1043C20.9524 70.1043 20.8565 69.1829 21.371 68.5264C21.8856 67.87 22.8141 67.7617 22.8141 67.7617Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9097 63.1172C21.9097 63.1172 22.2372 64.0109 21.9097 64.7733C21.664 65.2668 21.2501 65.6598 20.7403 65.8836C20.7403 65.8836 20.4105 64.9922 20.7403 64.2297C20.9858 63.7355 21.3997 63.3417 21.9097 63.1172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4253 61.5195C15.9304 61.8259 16.3267 62.279 16.5596 62.8163C16.7253 63.3579 16.7023 63.9384 16.4941 64.4656C15.9888 64.1605 15.5923 63.7081 15.3598 63.1711C15.1936 62.6288 15.2166 62.0474 15.4253 61.5195Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4545 67.1934C18.4545 67.1934 19.0532 67.9512 19.0041 68.7919C18.9415 69.3434 18.685 69.856 18.2791 70.2408C18.2791 70.2408 17.6803 69.4852 17.7294 68.6422C17.7926 68.0909 18.049 67.5785 18.4545 67.1934Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2847 59.0137C18.2847 59.0137 18.8834 59.7715 18.8343 60.6261C18.771 61.1771 18.5136 61.689 18.1069 62.0726C18.1069 62.0726 17.5105 61.3171 17.5573 60.474C17.6182 59.9183 17.8757 59.4013 18.2847 59.0137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5148 76.0244C11.4729 76.5978 11.6206 77.1691 11.9358 77.6529C12.3062 78.1075 12.8115 78.4369 13.3812 78.595C13.4244 78.0215 13.2766 77.4498 12.9602 76.9665C12.5902 76.5114 12.0847 76.182 11.5148 76.0244Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75726 80.9443C9.7144 81.5178 9.86217 82.0894 10.1782 82.5728C10.5482 83.0279 11.0537 83.3574 11.6236 83.5149C11.6655 82.9416 11.5178 82.3703 11.2027 81.8864C10.8322 81.4318 10.3269 81.1025 9.75726 80.9443Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4292 83.0547C14.386 83.6282 14.5338 84.1999 14.8502 84.6832C15.2197 85.1393 15.7253 85.4697 16.2956 85.6276C16.3375 85.0542 16.1898 84.4829 15.8746 83.9991C15.5048 83.5434 14.9993 83.2132 14.4292 83.0547Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7061 76.166C15.498 76.6932 15.475 77.2737 15.6406 77.8152C15.8746 78.3521 16.2717 78.8043 16.7773 79.1098C16.9859 78.5826 17.0082 78.0016 16.8405 77.4605C16.6079 76.9235 16.2115 76.4711 15.7061 76.166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4141 94.5007C12.4141 94.5007 13.3496 94.5767 14.0068 94.0561C14.664 93.5355 14.7552 92.6211 14.7552 92.6211C14.7552 92.6211 13.8197 92.5451 13.1625 93.0633C12.5053 93.5816 12.4141 94.5007 12.4141 94.5007Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4922 94.0407C21.6657 94.5983 22.0126 95.0882 22.4839 95.4412C22.9823 95.7405 23.5656 95.873 24.1468 95.819C23.973 95.2609 23.6262 94.7704 23.1551 94.4162C22.6567 94.117 22.0732 93.9852 21.4922 94.0407Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4445 71.5068C13.4026 72.0802 13.5503 72.6515 13.8654 73.1353C14.2353 73.591 14.7407 73.9213 15.3108 74.0797C15.354 73.5063 15.2062 72.9345 14.8899 72.4512C14.5204 71.9951 14.0148 71.6647 13.4445 71.5068Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4291 67.4238C13.3863 67.9973 13.534 68.5689 13.8501 69.0523C14.2188 69.5108 14.7244 69.8436 15.2955 70.0036C15.3374 69.4303 15.1897 68.859 14.8745 68.3751C14.5055 67.9171 14 67.5844 13.4291 67.4238Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9451 127.992H9.85156V132.544H25.9451V127.992Z",
    fill: "#9FA6A8",
    stroke: "#0E1213",
    strokeWidth: 1.27916,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6359_86678"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 166.291,
    height: 166.291,
    fill: "white",
    transform: "translate(0.851562 0.291016)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyonWhatsapp3);
export default __webpack_public_path__ + "static/media/buyonWhatsapp3.1c9d5938b166153bfb0505c67fed794f.svg";
export { ForwardRef as ReactComponent };